module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ZOMA","short_name":"ZOMA","start_url":"/","background_color":"#fff","theme_color":"#ED1D24","display":"standalone","icon":"assets/img/logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"c422b293e79354faaa1fbcb33129aa91"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
